const password = {
    unsupported_encryption_method: 'O método de criptografia {{name}} não é suportado.',
    pepper_not_found: 'Password pepper não encontrada. Por favor, verifique seus envs principais.',
};
export default password;
